export const mapToArray = <T>(map: Map<any, T>) => {
  return Array.from(map, ({ 1: value }) => value) as T[];
};
